$(document).ready(function () {

    function htmlElemmentToString(who, deep) {
        if (!who || !who.tagName) return '';
        var txt, ax, el = document.createElement("div");
        el.appendChild(who.cloneNode(false));
        txt = el.innerHTML;
        if (deep) {
            ax = txt.indexOf('>') + 1;
            txt = txt.substring(0, ax) + who.innerHTML + txt.substring(ax);
        }
        el = null;
        return txt;
    }

    //function is to ensure compatibilty across browsers
    // returns a string of p elements
    function buildParagraphs(paragraphElements) {

        var paragraphs = ""

        for (var i = 0; i < paragraphElements.length; i++) {
            paragraphs += '<div>' + htmlElemmentToString(paragraphElements[i], true) + '</div>';

        }
        paragraphElements.remove();
        return paragraphs;
    }

    //returns array of tab objects
    function getDeleteElements() {
        var h5Elements = $('#description h5');
        var tabObjects = [];
        for (var i = 0; i < h5Elements.length; i++) {
            tabObjects.push(
                {
                    header: h5Elements[i].innerText,
                    content: buildParagraphs($(h5Elements[i]).nextUntil('h5'))
                }
            )
            $(h5Elements[i]).remove();
        }
        return tabObjects;
    }


    function buildTabHeader(tabObject) {
        var element = document.createElement('button');
        element.id = tabObject.header + "tab"
        element.className = "tablinks";
        element.innerText = tabObject.header;
        element.addEventListener("click", function () {
            var tabcontent = document.getElementsByClassName("tabcontent");
            for (i = 0; i < tabcontent.length; i++) {
                tabcontent[i].style.display = "none";
            }
            var tablinks = document.getElementsByClassName("tablinks");
            for (i = 0; i < tablinks.length; i++) {
                tablinks[i].className = tablinks[i].className.replace(" active", "");
            }
            document.getElementById(tabObject.header).style.display = "block";
            this.className += " active";
        })
        return element;
    }

    function buildContent(tabObject) {
        var element = '<div id="' + tabObject.header + '" class="tabcontent">' +
            tabObject.content +
            '</div>';

        return element;
    }

    var tabObjects = getDeleteElements();

    for (var i = 0; i < tabObjects.length; i++) {
        $('#tab-headers').append(buildTabHeader(tabObjects[i]));
        $('#tab-stuff').append(buildContent(tabObjects[i]));
    }
    try {

        document.getElementById(tabObjects[0].header + 'tab').className += ' active';
        document.getElementById(tabObjects[0].header).style.display = "block";
        $('#description').show();
    } catch (e) {
        console.log('No Tabs are present');
        //console.log(e);
        $('#description').show();
    }

});